import { useQuery } from "@tanstack/react-query";

import LeadService from "services/Lead";

export const SWOOGO_REGISTRANT_LEADS_QUERY_KEY = "swoogo-registrant-leads";

const EMPTY = new Map();

// The ids are sorted so every caller that asks for the same registrants, such
// as each cell of one table page, shares a single request.
export default function useSwoogoRegistrantLeads(registrantIds) {
  const sortedIds = [...registrantIds].sort((a, b) => a - b);
  const { data, isSuccess } = useQuery({
    queryKey: [SWOOGO_REGISTRANT_LEADS_QUERY_KEY, sortedIds],
    queryFn: () => LeadService.getSwoogoRegistrantLeads(sortedIds),
    enabled: sortedIds.length > 0,
  });
  const leadsByRegistrant = data
    ? new Map(data.map(row => [row.registrant_id, row]))
    : EMPTY;
  return { leadsByRegistrant, isLoaded: isSuccess };
}
